/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('table').forEach(this.#formatTable);
  }

  /**
   * Formats a table for easier styling.
   * The wrapper scrolls on narrow screens, so it takes keyboard focus and a name (axe
   * scrollable-region-focusable). Each cell gets its column header as data-label, which the
   * collection description uses to show one card per row on mobile (assets/redesign.css).
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-table-wrapper');
    const headerRow = table.tHead?.rows[0];
    const labels = headerRow ? [...headerRow.cells].map((cell) => cell.textContent.trim()) : [];
    let heading = table.previousElementSibling;
    while (heading && !/^H[2-4]$/.test(heading.tagName)) heading = heading.previousElementSibling;
    const name = table.caption?.textContent.trim() || heading?.textContent.trim() || labels[0];
    wrapper.tabIndex = 0;
    wrapper.setAttribute('role', 'region');
    if (name) wrapper.setAttribute('aria-label', name);
    for (const body of table.tBodies) {
      for (const row of body.rows) {
        [...row.cells].forEach((cell, i) => {
          if (labels[i]) cell.dataset.label = labels[i];
        });
      }
    }
    const parent = table.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }
}

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}
